export function Locations() {
  const locations = [
    {
      city: 'Los Angeles Office',
      address: '1055 Wilshire Blvd Suite #1930, Los Angeles, CA 90017',
      phone: '(818) 221-8000',
      mapUrl: 'https://www.google.com/maps/place/1055+Wilshire+Blvd+Suite+1930,+Los+Angeles,+CA+90017'
    },
    {
      city: 'Brentwood, CA',
      address: '11710 Wilshire Blvd, Brentwood, CA 90025',
      phone: '(800) 974-5633',
      mapUrl: 'https://www.google.com/maps/place/11710+Wilshire+Blvd,+Los+Angeles,+CA+90025,+USA/@34.0489111,-118.4638429,17z/data=!3m1!4b1!4m6!3m5!1s0x80c2bb67311542b5:0x9a6c5efd521baa3!8m2!3d34.0489111!4d-118.4612626!16s%2Fg%2F11c2dl8srr?entry=ttu&g_ep=EgoyMDI1MDExMC4wIKXMDSoASAFQAw%3D%3D'
    },
    {
      city: 'Covina, CA',
      address: '970 S Village Oaks Dr Suite 100, Covina, CA 91724',
      phone: '(800) 974-5633',
      mapUrl: 'https://www.google.com/maps/place/970+S+Village+Oaks+Dr+Suite+100,+Covina,+CA+91724'
    },
    {
      city: 'Glendale, CA',
      address: '1577 E. Chevy Chase Drive, Suite 110, Glendale, CA 91206',
      phone: '(818) 221-8000',
      mapUrl: 'https://www.google.com/maps/place/1577+E+Chevy+Chase+Dr+Suite+110,+Glendale,+CA+91206'
    },
    {
      city: 'Downey, CA',
      address: '10800 Paramount Blvd #307, Downey, CA 90241',
      phone: '(800) 974-5633',
      mapUrl: 'https://www.google.com/maps/place/10800+Paramount+Blvd+%23307,+Downey,+CA+90241'
    },
    {
      city: 'Loma Linda, CA',
      address: '11370 Anderson St, Loma Linda, CA 92354',
      phone: '(800) 974-5633',
      mapUrl: 'https://www.google.com/maps/place/11370+Anderson+St,+Loma+Linda,+CA+92354,+USA/@34.0471369,-117.264405,17z/data=!3m1!4b1!4m6!3m5!1s0x80dcab8933f5620d:0x676ae13f9394d92!8m2!3d34.0471369!4d-117.2618247!16s%2Fg%2F12hpb4lr0?entry=ttu&g_ep=EgoyMDI1MDExMC4wIKXMDSoASAFQAw%3D%3D',
      note: 'Loma Linda Hospital'
    }
  ];

  return (
    <section id="locations" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 text-center mb-3 sm:mb-4">
          Our Locations
        </h2>
        <p className="text-base sm:text-lg text-slate-600 text-center mb-12 sm:mb-16 px-4">
          We are happy to hear from you! Please use the following contact details to get in touch for any appointments or inquiries.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {locations.map((location, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-lg p-5 sm:p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <h3 className="text-lg sm:text-xl font-semibold text-slate-900 mb-3 sm:mb-4">
                {location.city}
              </h3>
              <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-slate-600">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-slate-900 mt-1 flex-shrink-0"></i>
                  <span>{location.address}</span>
                </li>
                {location.phone && (
                  <li className="flex items-start gap-2">
                    <i className="ri-phone-line text-slate-900 mt-1 flex-shrink-0"></i>
                    <a href={`tel:${location.phone}`} className="hover:text-slate-900 transition-colors cursor-pointer">
                      {location.phone}
                    </a>
                  </li>
                )}
                {location.note && (
                  <li className="flex items-start gap-2">
                    <i className="ri-hospital-line text-slate-900 mt-1 flex-shrink-0"></i>
                    <span>{location.note}</span>
                  </li>
                )}
                <li>
                  <a
                    href={location.mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-slate-900 font-medium hover:text-slate-700 transition-colors cursor-pointer"
                  >
                    <i className="ri-navigation-line"></i>
                    Driving Directions
                  </a>
                </li>
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <a
            href="tel:1-800-974-5633"
            className="inline-flex items-center gap-2 bg-slate-900 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-medium hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            Call Now
          </a>
        </div>
      </div>
    </section>
  );
}